import { DragDropContext, Droppable } from "react-beautiful-dnd";
import cx from "classnames";
import ReviewStageListItem from "../review-stage-list-item/review-stage-list-item.component";
import React from "react";
import { withShowIf } from "../../with-show-if/with-show-If.component";
import { ListContainer, ListStyledOrder } from "./review-stage-draggable-list-view.styles";
import { ReviewStageDraggableListViewProps } from "./review-stage-draggable-list-view.props";

export const ReviewStageDraggableListView = withShowIf(
  (props: ReviewStageDraggableListViewProps) => (
    <ListContainer>
      <DragDropContext onDragEnd={props.onDragEnd}>
        <Droppable droppableId="droppable" isDropDisabled={!props.canManageReviewers}>
          {(provided) => (
            <ListStyledOrder
              ref={provided.innerRef}
              className={cx({ "edit-mode": props.canManageReviewers })}
            >
              {props.stages.map((stage, index) => (
                <ReviewStageListItem
                  key={stage.id}
                  stage={stage}
                  pageType={props.pageType}
                  index={index}
                />
              ))}
              {provided.placeholder}
            </ListStyledOrder>
          )}
        </Droppable>
      </DragDropContext>
      {props.children}
    </ListContainer>
  )
);
